export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: id === "start" ? 0 : id === "angebot" ? -88 : -64, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const goTo = (id) => (e) => {
  if (!document.getElementById(id)) return;
  e.preventDefault();
  scrollToId(id);
};

export const requestOffer = (service) => {
  window.dispatchEvent(new CustomEvent("cb:service", { detail: service }));
  if (document.getElementById("angebot")) scrollToId("angebot");
  else window.location.assign("/#angebot");
};
